import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Card from "../../../componentes/contenedores/Card";
import CardCatalogo from "../../../componentes/contenedores/CardCatalogo";
import CardTipo from "../../../componentes/contenedores/CardTipo";
import CardCatalogoLista from "../../../componentes/contenedores/CardCatalogoList";
import CardCatalogoSmall from "../../../componentes/contenedores/CardCatalogoSmall";
import Page from "../../../componentes/plantilla/Page";
import {
  ImagenProducto,
  ImagenTipoProducto
} from "../../../configuracion/apiUrls";
import { useContextCliente } from "../../../contexto/cliente/ClienteContext";
import { useContextUsuario } from "../../../contexto/usuario/UsuarioContext";
import { mostraAlertaOk } from "../../../componentes/alerts/sweetAlert";

const ProductosCatalogo = () => {
  const { listaProductos = [], listaCategoriaProductos } = useContextCliente();
  const { setCarritoPedidos, setCarritoCotizacion } = useContextUsuario();
  const [productos, setProductos] = useState([]);
  const [tipos, setTipos] = useState([]);
  const [filtroTipo, setFiltroTipo] = useState(null);
  const [panelAbierto, setPanelAbierto] = useState(false);
  const [vistaActual, setVistaActual] = useState("card-lg");
  const navigate = useNavigate();
  const productosRef = useRef(null);

  const datos = {
    titulo: {
      titulo: "Catálogo de productos",
      url: "/app/clientes/productos",
      tituloUrl: "productos",
      nombreUrl: "Catálogo Productos",
    },
  };

  useEffect(() => {
    cargarTiposProductos();
  }, [listaCategoriaProductos]);

  useEffect(() => {
    //cargarProductos(listaProductos);
  }, [listaProductos]);

  const cargarTiposProductos = () => {
    if (listaCategoriaProductos && Array.isArray(listaCategoriaProductos)) {
      const transformados = listaCategoriaProductos.map((tipo) => ({
        id: tipo.id,
        nombre: tipo.nombre,
        descripcion: tipo.descripcion,
        estado: tipo.estado,
        imagen: tipo.imagen ? ImagenTipoProducto + tipo.imagen : "/productos.jpg",
      }));
      setTipos(transformados);
    }
  };

  const cargarProductos = (lista) => {
    if (!Array.isArray(lista) || lista.length === 0) {
      setProductos([]);
      return;
    }

    const transformados = lista.map((p) => {
      const imgs = p.productoImagens && Array.isArray(p.productoImagens) && p.productoImagens.length > 0
        ? p.productoImagens.map((imgObj) => ImagenProducto + imgObj.imagen)
        : ["/productos.jpg"];

      let precioParaMostrar = parseFloat(p.precio) || 0;

      const primerLoteActivo = (p.lotes || []).find(lote => lote.estado === "Disponible" && lote.existencia > 0);

      if (primerLoteActivo) {
        precioParaMostrar = parseFloat(primerLoteActivo.precio) || precioParaMostrar;
      }

      return {
        id: p.id,
        nombre: p.nombre,
        descripcion: p.descripcion,
        caracteristicas: p.caracteristicas || '',
        imagenes: imgs,
        existencia: p.existencia,
        precioConImpuesto: p.precioConImpuesto,
        precio: precioParaMostrar.toFixed(2),
        lotes: p.lotes || [],
        productoprecios: p.productoprecios || [],
        loteId: primerLoteActivo ? primerLoteActivo.id : null,
      };
    });

    setProductos(transformados);
  };

  const handleVerDetalles = (producto) => {
    navigate(`/app/clientes/producto/${producto.id}`, { state: { producto } });
  };

  const aplicarFiltro = (tipoId) => {
    setFiltroTipo(tipoId);
    let listaFiltrada = [];

    if (tipoId) {
      listaFiltrada = listaProductos.filter(
        (producto) => producto.productoTipoId == tipoId
      );
    } else {
      listaFiltrada = listaProductos;
    }
    cargarProductos(listaFiltrada);
    setTimeout(() => {
      if (productosRef.current) {
        productosRef.current.scrollIntoView({ behavior: "smooth" });
      }
    }, 200);
    setPanelAbierto(false);
  };

  const agregarAlCarritoProducto = (producto) => {
    setCarritoPedidos((prevCarrito) => {
      const existe = prevCarrito.find((item) => item.id === producto.id && item.loteId === producto.loteId);
      const cantidadInicial = existe ? existe.cantidad + 1 : 1;
      const price = (parseFloat(producto.precio) * cantidadInicial).toFixed(2);
      const imagenPrincipal = producto.imagenes && producto.imagenes.length > 0 ? producto.imagenes[0] : "/productos.jpg";

      if (existe) {
        return prevCarrito.map((item) =>
          item.id === producto.id && item.loteId === producto.loteId
            ? { ...item, cantidad: cantidadInicial, price: price, imagen: imagenPrincipal }
            : item
        );
      }
      return [...prevCarrito, { ...producto, cantidad: cantidadInicial, price: price, imagen: imagenPrincipal }];
    });
    mostraAlertaOk(`${producto.nombre} se ha agregado al carrito`, "Producto agregado");
  };

  const agregarAlCarritoCotizacion = (producto) => {
    setCarritoCotizacion((prevCarrito) => {
      const existe = prevCarrito.find((item) => item.id === producto.id && item.loteId === producto.loteId);
      const cantidadInicial = existe ? existe.cantidad + 1 : 1;
      const price = (parseFloat(producto.precio) * cantidadInicial).toFixed(2);
      const imagenPrincipal = producto.imagenes && producto.imagenes.length > 0 ? producto.imagenes[0] : "/productos.jpg";

      if (existe) {
        return prevCarrito.map((item) =>
          item.id === producto.id && item.loteId === producto.loteId
            ? { ...item, cantidad: cantidadInicial, price: price, imagen: imagenPrincipal }
            : item
        );
      }
      return [...prevCarrito, { ...producto, cantidad: cantidadInicial, price: price, imagen: imagenPrincipal }];
    });
    mostraAlertaOk(`${producto.nombre} se ha agregado ala cotizacion`, "Producto agregado");
  };


  const renderizarProductos = () => {
    if (productos.length === 0) {
      return (
        <div className="col-12 text-center py-5">
          <p className="lead text-muted">No hay productos disponibles para la categoría seleccionada.</p>
          <i className="fas fa-box-open text-primary" style={{ fontSize: '2rem' }}></i>
        </div>
      );
    }

    const componentes = {
      'card-lg': CardCatalogo,
      'card-sm': CardCatalogoSmall,
      'lista': CardCatalogoLista
    };

    const ComponenteActual = componentes[vistaActual];

    return productos.map((prod) => (
      <ComponenteActual
        key={prod.id}
        producto={prod}
        onAgregarClick={agregarAlCarritoProducto}
        onVerDetallesClick={handleVerDetalles}
        onCotizarClick={agregarAlCarritoCotizacion}
      />
    ));
  };

  return (
    <Page datos={datos}>
      <Card titulo="Categoría de Productos">
        <CardTipo
          categorias={[
            ...tipos,
            { id: null, nombre: "Todos", imagen: "/categoriaDefault.jpg" },
          ]}
          onSeleccionar={aplicarFiltro}
          activa={filtroTipo}
        />
      </Card>

      <Card>
        <div className="d-flex justify-content-end align-items-center">
          <div className="btn-group me-3 mx-4" role="group" aria-label="Cambiar vista">
            <button
              type="button"
              className={`btn ${vistaActual === 'card-lg' ? 'btn-primary' : 'btn-light'}`}
              onClick={() => setVistaActual('card-lg')}
              title="Vista de tarjeta grande"
            >
              <i className="fas fa-th-large"></i>
            </button>
            <button
              type="button"
              className={`btn ${vistaActual === 'card-sm' ? 'btn-primary' : 'btn-light'}`}
              onClick={() => setVistaActual('card-sm')}
              title="Vista de tarjeta pequeña"
            >
              <i className="fas fa-th"></i>
            </button>
            <button
              type="button"
              className={`btn ${vistaActual === 'lista' ? 'btn-primary' : 'btn-light'}`}
              onClick={() => setVistaActual('lista')}
              title="Vista de lista"
            >
              <i className="fas fa-list"></i>
            </button>
          </div>
          <div className="d-flex justify-content-end">
            <div className="position-relative" style={{ width: "100%", maxWidth: "250px" }}>
              <button
                className={`btn ${panelAbierto ? "btn-danger" : "btn-primary"} w-100 d-flex justify-content-between align-items-center`}
                onClick={() => setPanelAbierto(!panelAbierto)}
                style={{ borderRadius: "8px", padding: "10px 15px", fontSize: "1rem" }}
              >
                <span className="d-flex align-items-center">
                  <i className="fas fa-filter me-2 mx-2"></i>
                  Filtros
                </span>
                <i className={`fas fa-chevron-${panelAbierto ? "up mx-2" : "down mx-2"}`}></i>
              </button>

              {panelAbierto && (
                <div className="position-absolute top-100 mt-2 bg-body border border-secondary-subtle text-body shadow"
                  style={{
                    minWidth: "240px",
                    right: 0,
                    borderRadius: "10px",
                    backgroundColor: "#fff",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                    padding: "15px",
                    zIndex: 1050,
                    border: "1px solid red",
                  }}
                >
                  <h5 className="text-dark fw-bold mb-3 d-flex align-items-center">
                    <i className="fas fa-tags me-2 text-primary"></i>
                    Filtrar por Tipo
                  </h5>
                  <div className="filter-options d-flex flex-wrap gap-2" style={{ maxHeight: "150px", overflowY: "auto" }}>
                    {tipos.map((tipo) => (
                      <div
                        key={tipo.id}
                        className={`filter-badge ${filtroTipo === tipo.id ? "bg-primary text-white" : "bg-light text-dark"} p-2 rounded-pill d-flex align-items-center`}
                        style={{
                          cursor: "pointer",
                          fontSize: "0.9rem",
                          gap: "8px",
                          transition: "all 0.3s ease",
                        }}
                        onClick={() => aplicarFiltro(tipo.id)}
                      >
                        <i className="fas fa-tag"></i>
                        <span>{tipo.nombre}</span>
                      </div>
                    ))}
                    <div
                      className={`filter-badge ${filtroTipo === null ? "bg-primary text-white" : "bg-light text-dark"} p-2 rounded-pill d-flex align-items-center`}
                      style={{
                        cursor: "pointer",
                        fontSize: "0.9rem",
                        gap: "8px",
                        transition: "all 0.3s ease",
                      }}
                      onClick={() => aplicarFiltro(null)}
                    >
                      <i className="fas fa-tag"></i>
                      <span>Todos</span>
                    </div>
                  </div>
                  <button
                    className="btn btn-warning w-100 mt-3 fw-bold"
                    onClick={() => aplicarFiltro(null)}
                    style={{ padding: "8px", fontSize: "0.9rem" }}
                  >
                    <i className="fas fa-times mx-2"></i>
                    Limpiar Filtros
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        <div ref={productosRef} id="productos-lista" className="row g-4 my-4">
          {renderizarProductos()}
        </div>
      </Card>
    </Page>
  );
};

export default ProductosCatalogo;